import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTeamManagementShelf } from '../selectors';
import { closeShelfCalled, wizardFinished, wizardActionTypeChanged } from '../actions';
import TeamManagementShelf from '../components/TeamManagementShelf';

const mapStateToProps = state => getTeamManagementShelf(state);

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            onCloseShelf: closeShelfCalled,
            onWizardFinish: wizardFinished,
            onWizardActionTypeChanged: wizardActionTypeChanged,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(TeamManagementShelf);
